module.exports = __webpack_public_path__ + "media/images/athletes/134-dd618b6d13b8613ecde9bfc860576d75.png";